/**
 * @license Copyright (c) 2022, Memo.ph by Globe Telecom. All rights reserved.
 */
import React from 'react';
import TableHeaderCell from '../../../layouts/table/TableHeaderCell';
import TableRow from '../../../layouts/table/TableRow';
import { DatatableComponentProps, ITableHeader } from '../datatable/Datatable';

const HistoryMemosTableHeader = (props: DatatableComponentProps) => {
    if (!props.headers) {
        return <TableRow type="header" />;
    }
    return (
        <TableRow type="header">
            {props.headers!.map((header: ITableHeader) => {
                return <TableHeaderCell key={header.key}>{header.label}</TableHeaderCell>;
            })}
        </TableRow>
    );
};

export default HistoryMemosTableHeader;
